import { onboarded } from "modules/user/onboarding/hoc";

export default onboarded(() => "Main page");



// WEBPACK FOOTER //
// ./src/components/generic/pages/Main/index.js